import React from 'react';

import AppImage from '@/components/Image/AppImage';
import appConfig from '@/config/appConfig.typed';
import urlUtils from '@/utils/urlUtils';

const RemoteIconV2 = ({icon, className}) => {
    if (!icon) return null;

    const {path, alt} = icon;

    if (!path) return null;

    const imageSrc = urlUtils.join(appConfig.getContentPath(), path);

    return <AppImage className={className} src={imageSrc} alt={alt} />;
};

export default RemoteIconV2;
